var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"artificialIntelligence",attrs:{"element-loading-text":"数据加载中","element-loading-background":"rgba(255, 255, 255, 1)"}},[_c('iframe',{ref:"ifra",attrs:{"allowTransparency":"true","scrolling":"no","src":_vm.src}})])
}
var staticRenderFns = []

export { render, staticRenderFns }